var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewamerica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 588.17 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NA_logo_optimized") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.12,
    y: 115.73,
    width: 190.31,
    height: 27.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.12,
    y: 58.4,
    width: 190.31,
    height: 28.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.6,
    y: 1.05,
    width: 143.82,
    height: 28.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.28,31.75c8.45,0,15.29-7.1,15.29-15.88S23.73,0,15.28,0,0,7.11,0,15.87,6.85,31.75,15.28,31.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M558.66,101l5.23,15.27H553.42ZM573,142.87h15.19l-22-60.36H551.1l-20.75,60.36h14.06l4.89-14.39H568Zm-54.65-17A16.93,16.93,0,0,1,507,130.41c-9.95,0-16.56-7.77-16.56-17.72S496.37,95,506.92,95a16.81,16.81,0,0,1,11.41,4.54l8.5-11c-4.72-4.19-11.07-7.15-20.08-7.15-19,0-31.31,14-31.31,31.39,0,17.64,11.83,31.23,31.57,31.23a27.25,27.25,0,0,0,19.74-7.84ZM467,82.51H452.67v60.36H467Zm-45.9,12.55c3.17,0,5.15,2.19,5.15,5.5s-1.89,5.68-5.15,5.68h-5V95.06Zm19.9,5.42c0-11.43-6.26-18-18.7-18H401.87v60.36h14.24V118.09H420l11.67,24.78H447L433.44,115.3c4.8-3,7.55-8.1,7.55-14.82m-49.36,42.39v-13.6H377.56V118.88H391V105.45H377.56V96.11h13.82V82.51H363.25v60.36Zm-53.26-42.39v42.39h13.8V82.51h-21L318,123.41,304.9,82.51H283.45v60.36h13.2V100.48l14.08,42.39h13.56Zm-90,.52,5.24,15.27H243.1Zm14.33,41.87h15.18l-22-60.36H240.79L220,142.87h14.07L239,128.48h18.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.53,1.05V37.51L238.2,1.05H223.46V61.4h13.81V25.73L260.19,61.4h14.14V1.05Zm24.83,0V61.4h28.39V47.81H299.68V37.42h13.39V24H299.68V14.64H313.5V1.05Zm106.74,0-9.7,41.07L372,1.05H356.66L346.29,42.12,336.58,1.05H320.89L337.28,61.4h16.38L364,23.47,374.16,61.4H391l16-60.35Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewamerica);
export default __webpack_public_path__ + "static/media/newamerica.52297c3fd242e905268ef6f1e4b227f9.svg";
export { ForwardRef as ReactComponent };